<template>
  <MemberForm :isEdit="true" :memberId="id || $route.params.id" />
</template>

<script>
import MemberForm from '@/components/team-members/MemberForm.vue';

export default {
  name: "MembersEditPage",
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    MemberForm,
  },
};
</script>
